import React from 'react';
import { Icon, Button } from '@abb/abb-common-ux-react';
import * as CONSTANTS from "../../utilities/Constants";
import { Translation, useTranslation } from 'react-i18next';
import { FileUploader } from "react-drag-drop-files";
import getLicenseDetailsStore from '../../flux/stores/license/GetLicenseDetailsStore';
import licenseActions from '../../flux/actions/LicenseActions';
import triggerNotifications from '../../utilities/TriggerNotifications';
import uploadLicenseFileStore from '../../flux/stores/license/uploadLicenseFileStore';
import Landing from './Landing';
import History from "../../utilities/History";
import auth from "../../utilities/Auth";
import i18next from 'i18next';

interface IState {
  file: any;
  licenseFileData: any;
  licenseDetails: any;
  expirationDate: string;
  isLifeTimeValid: boolean;
  isFileUploadFailed: boolean;
  isLicenseApplicable: boolean;
  isErrorFileType: boolean;
}

export default class LicenseManagement extends React.Component<{}, IState> {
  private _mount: boolean = false;
  private _listData: any = [];

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      file: null,
      licenseDetails: [],
      licenseFileData: [],
      expirationDate: "",
      isLifeTimeValid: false,
      isFileUploadFailed: false,
      isLicenseApplicable: false,
      isErrorFileType: false
    };
  }

  getLicenseData = () => {
    licenseActions
      .getLicenseDetails()
      .then(async () => {
        let responses: any = this.state.licenseDetails?.filter((x: any) => x.isActive === true && x.hasValidLicense === true);
        const isAnyLicenseNotApplicable = this.state.licenseDetails?.some((node: any) => !node.isLicenseApplicable);
        // let responses: any = await import('../../../public/test.json');
        // let isAnyLicenseNotApplicable: any = responses.default.some((node: any) => !node.isLicenseApplicable);
        // responses = responses.default.filter((x: any) => x.isActive === true && x.hasValidLicense === true);
        let response: any;
        if (isAnyLicenseNotApplicable) {
          this.setState({ isLicenseApplicable: false });
        } else {
          this.setState({ isLicenseApplicable: true });
          if (responses) {
            response = responses[0];
          }
          let expirationDate = this.state.licenseDetails.filter((x: any) => x.licenseType === "Subscription");
          if (expirationDate.length !== 0) {
            this.setState({ expirationDate: this.dateFormat(expirationDate[0].expiryDate) });
          }
          if (response !== undefined) {
            if (responses?.length !== 0) {
              if (response?.isLicenseApplicable) {
                if (response?.hasValidLicense) {
                  this.setState({ file: null })
                  if (response?.isLifeTimeLicense) {
                    this.setState({ isLifeTimeValid: true });
                  } else if (response?.expiryDate !== "") {
                    this.setState({ isLifeTimeValid: false });
                  }
                } else {

                }
              }
            } else {
              this.logout();
            }
          } else {
            this.logout();
          }
        }
      })
      .catch((error) => {
        console.log("License Management error", error);
        // triggerNotifications.error(error?.error_description ?? "Error occurred while fetching license details");
      });
  }

  logout = (): void => {
    auth.removeTokens();
    setTimeout(() => {
      History.push(CONSTANTS.LOGIN_URL);
    }, 200)
  };

  dateFormat = (date: string) => {
    let dateObj = new Date(date);
    return dateObj.toDateString();
  }

  handleFileUpload = (file: any) => {
    const formData = new FormData();
    formData.append('file', file);
    licenseActions
      .uploadLicenseFile(formData)
      .then(() => {
        let response: any = this.state.licenseFileData
        if (response && response === true) {
          triggerNotifications.success([i18next.t(CONSTANTS.FILE_UPLOAD_SUCCESS)]);
          this.setState({ isFileUploadFailed: false })
          this.getLicenseData();
        } else {
          this.setState({ isFileUploadFailed: true })
          triggerNotifications.error(i18next.t(CONSTANTS.FILE_UPLOAD_FAILED));
        }
      })
      .catch((error) => {
        this.setState({ isFileUploadFailed: true })
        triggerNotifications.error(error?.error_description ?? i18next.t(CONSTANTS.FILE_UPLOAD_FAILED));
      });
  }

  handleChange = (file: any) => {
    this.setState({ file, isFileUploadFailed: false, isErrorFileType: false});
  };

  onTypeError = (file: any) => {
    this.setState({ file, isErrorFileType: true, isFileUploadFailed: false });
  }


  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
    getLicenseDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this.setState({ licenseDetails: state.licenseData.data });
    });

    uploadLicenseFileStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this.setState({ licenseFileData: state.licenseData.data });
    });

    this.getLicenseData();
  }

  public render() {
    return (
      <React.Fragment>
        {this.state.isLicenseApplicable ? (<Landing
          file={this.state.file}
          licenseFileData={this.state.licenseFileData}
          licenseDetails={this.state.licenseDetails}
          expirationDate={this.state.expirationDate}
          isLifeTimeValid={this.state.isLifeTimeValid}
          handleChange={this.handleChange}
          handleFileUpload={this.handleFileUpload}
          isFileUploadFailed={this.state.isFileUploadFailed}
          onTypeError={this.onTypeError}
          isErrorFileType={this.state.isErrorFileType}
        />) : (<></>)}
      </React.Fragment>
    );
  }
}
